import React from "react";

const Jumbotron = ({ isError, children }) => (
  <div className={`jumbotron ${isError ? "jumbo_error" : ""}`}>{children}</div>
);

export default Jumbotron;
